import { ReadingEventMessage } from 'src/types/readings/readings';

export const setLiveDataMessages = (
  prevState: ReadingEventMessage[],
  messages: ReadingEventMessage
): ReadingEventMessage[] => {
  const existingGateway = prevState.find((item) => item.data.sourceId === messages.data.sourceId);

  if (!existingGateway) {
    return [...prevState, messages];
  }

  const tagMap = new Map(existingGateway.data.data.map((tag) => [tag.id, tag]));

  messages.data.data.forEach((tag: any) => {
    tagMap.set(tag.id, tag);
  });

  const updatedGateway = {
    ...existingGateway,
    data: {
      ...existingGateway.data,
      data: Array.from(tagMap.values()),
      timestamp: messages.data.timestamp,
      action: messages.data.action,
    },
  };

  const filteredItems = prevState.filter((item) => item.data.sourceId !== messages.data.sourceId);

  return [...filteredItems, updatedGateway];
};
